/**
 * Number formatting helpers shared across vacancy forms (e.g. DECIMAL(18, 2) budget fields).
 */

/** Format a value with thousand separators; preserves up to 2 decimal places. */
export const formatNumberWithCommas = (
  value: string | number | null | undefined,
): string => {
  if (!value && value !== 0) return '';
  const numStr = value.toString().replace(/,/g, '');
  if (numStr === '' || isNaN(Number(numStr))) return '';

  const num = parseFloat(numStr);
  if (isNaN(num)) return '';

  return num.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

/** Remove comma separators from a numeric string. */
export const removeCommas = (value: string): string => {
  return value.replace(/,/g, '');
};
